
function paramsToObject(entries: any, prefix: string = "") {
    const result: any = {}
    for (const [key, value] of entries) {
        result[`${prefix}${key}`] = value;
    }
    return result;
}

function formatDate(date: string | number) {
    const d = new Date(date);
    return d.toLocaleDateString("pt-br", {
        timeZone: "Europe/London"
    });
}

function timestampToDate(timestamp: number) {
    return new Date(timestamp * 1000).toLocaleDateString("pt-br");
}

function removeLineBreak(text: string) {
    //text = text.replace(/\n/g, "<br />");
    text = text.replace(/\t/g, "");

    return text;
}

function strippedString(originalString: string) {
    return originalString.replace(/(<([^>]+)>)/gi, "");
}

function getHost() {
    return window.location.protocol + '//' + window.location.host;
}

function convertLineBreakToSpace(str: string) {
    return str.replace(/\n/g, ' ').replace(/\s+/g, " ");
}

export {
    paramsToObject,
    formatDate,
    removeLineBreak,
    strippedString,
    convertLineBreakToSpace,
    getHost,
    timestampToDate
}